import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaDownload, FaCalendarAlt, FaSignOutAlt, FaRedo } from "react-icons/fa";
import "./AayVyayPatrak.css"; 
import topLogo from "./logo-placeholder.png"; 

const AayVyayPatrak = () => {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [incomeData, setIncomeData] = useState([]);
  const [expenseData, setExpenseData] = useState([]);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  
  const [hasSearched, setHasSearched] = useState(false);
  
  // --- MANUAL ENTRY STATES ---
  const [manualIncome1, setManualIncome1] = useState({ category: "", amount: "" });
  const [manualIncome2, setManualIncome2] = useState({ category: "", amount: "" });
  const [manualExpense1, setManualExpense1] = useState({ category: "", amount: "" });
  const [manualExpense2, setManualExpense2] = useState({ category: "", amount: "" });

  // --- PROGRESS BAR STATES ---
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!fromDate || !toDate) return;
    
    setIsLoading(true);
    setHasSearched(true);
    setProgress(10);

    const progressInterval = setInterval(() => {
        setProgress((prev) => {
            if (prev >= 90) return 90; 
            return prev + 10;
        });
    }, 200);

    try {
      const response = await fetch("/api/dashboard/aay-vyay-patrak", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fromDate, toDate }),
      });
      const result = await response.json();
      
      clearInterval(progressInterval); 

      if (result.success) {
        setProgress(100); 
        setTimeout(() => {
            setIncomeData(result.incomeData);
            setExpenseData(result.expenseData);
            setTotalIncome(result.totalIncome);
            setTotalExpense(result.totalExpense);
            setIsLoading(false);
            setProgress(0);
        }, 500);
      } else {
        setIsLoading(false);
        setProgress(0);
        alert(result.message);
      }
    } catch (error) {
      clearInterval(progressInterval);
      setIsLoading(false);
      setProgress(0);
      alert("Server Connection Error.");
    }
  };

  const handleReset = () => {
    setFromDate(""); setToDate(""); setIncomeData([]); setExpenseData([]);
    setTotalIncome(0); setTotalExpense(0); setHasSearched(false);
    setManualIncome1({ category: "", amount: "" });
    setManualIncome2({ category: "", amount: "" });
    setManualExpense1({ category: "", amount: "" });
    setManualExpense2({ category: "", amount: "" });
  };

  const handleLogout = () => {
        if(window.confirm("Do you want to Sign Out?")) {
            localStorage.clear();
            navigate('/'); 
        }
    };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const parts = dateString.split("-");
    if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`; 
    return dateString;
  };

  let displayYear = "";
  if (fromDate && toDate) {
      const startYear = fromDate.split("-")[0];
      const endYear = toDate.split("-")[0];
      displayYear = startYear === endYear ? startYear : `${startYear}-${endYear}`;
  }

  const finalTotalIncome = totalIncome + (Number(manualIncome1.amount) || 0) + (Number(manualIncome2.amount) || 0);
  const finalTotalExpense = totalExpense + (Number(manualExpense1.amount) || 0) + (Number(manualExpense2.amount) || 0);

  // SMART LOGIC: Total Rows will be (Max DB data) + (2 Manual Rows)
  const maxRows = Math.max(incomeData.length, expenseData.length) + 2;
  const tableRows = Array.from({ length: maxRows });

  return (
    <div className="patrak-page-container">
      {/* --- TOP NAV BAR --- */}
      <div className="patrak-top-nav hide-in-pdf">
        <div className="patrak-brand" onClick={() => navigate("/home")}>
          <img src={topLogo} alt="Logo" className="patrak-logo" />
          <div className="patrak-brand-text">
            <h2>गायत्री परिवार</h2>
            <h3>अलीराजपुर</h3>
          </div>
        </div>
        <button className="patrak-logout-btn" onClick={handleLogout} title="Sign Out">
            <FaSignOutAlt size={18} /> <span>Sign Out</span>
        </button>
      </div>

      <div className="patrak-form-card">
        <h2 className="patrak-title">
            गायत्री परिवार अलीराजपुर आय-व्यय पत्रक <br className="mobile-break" />
            {hasSearched && <span className="patrak-subtitle"> (दिनांक {formatDate(fromDate)} से {formatDate(toDate)})</span>}
        </h2>

        <form className="hide-in-pdf" onSubmit={handleSearch}>
          <div className="patrak-input-grid">
            <div className="patrak-input-group">
              <label>From Date (दिनांक से)</label>
              <div className="patrak-input-wrapper">
                <FaCalendarAlt className="input-icon" />
                <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} required />
              </div>
            </div>
            <div className="patrak-input-group">
              <label>To Date (दिनांक तक)</label>
              <div className="patrak-input-wrapper">
                <FaCalendarAlt className="input-icon" />
                <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} required />
              </div>
            </div>
          </div>
          <div className="patrak-btn-grid">
            <button type="submit" className="patrak-action-btn btn-purple" disabled={isLoading}>
              <FaSearch /> {isLoading ? "खोज रहे हैं..." : "SEARCH"}
            </button>
            <button type="button" className="patrak-action-btn btn-red" onClick={handleReset}>
              <FaRedo /> RESET
            </button>
          </div>
        </form>

        {isLoading && (
          <div style={{ marginTop: '20px', padding: '20px 0', textAlign: 'center' }}>
            <div style={{ maxWidth: '300px', margin: '0 auto' }}>
              <div style={{ background: '#e0e0e0', borderRadius: '10px', height: '12px', overflow: 'hidden', marginBottom: '10px' }}>
                <div style={{ width: `${progress}%`, background: 'linear-gradient(90deg, #9c27b0, #7b1fa2)', height: '100%', transition: 'width 0.3s ease', borderRadius: '10px' }}></div>
              </div>
              <p style={{ color: '#4a148c', fontWeight: 'bold', margin: 0 }}>डाटा प्रोसेस हो रहा है... {progress}%</p>
            </div>
          </div>
        )}

        {!isLoading && hasSearched && (
          <div className="patrak-table-container">
            <table className="patrak-table">
              <thead>
                <tr><th colSpan="4" className="table-main-heading">गायत्री परिवार अलीराजपुर आय-व्यय पत्रक</th></tr>
                <tr>
                  <th colSpan="4" style={{ fontWeight: 'normal', padding: '10px' }}>
                    <div className="table-header-flex">
                      <span>आय व्यय पत्रक वर्ष: <strong>{displayYear}</strong></span>
                      <span>दिनांक <strong>{formatDate(fromDate)}</strong> - <strong>{formatDate(toDate)}</strong></span>
                    </div>
                  </th>
                </tr>
                <tr><th colSpan="4" className="table-sub-heading">महायोग</th></tr>
                <tr>
                  <th colSpan="2" className="text-green total-box">कुल आय: ₹ {finalTotalIncome}</th>
                  <th colSpan="2" className="text-red total-box">कुल व्यय: ₹ {finalTotalExpense}</th>
                </tr>
                <tr className="col-headers">
                    <th colSpan="2">आय (Income)</th>
                    <th colSpan="2">व्यय (Expense)</th>
                </tr>
                <tr className="col-sub-headers">
                    <th>मद</th><th style={{textAlign: 'right'}}>राशि</th>
                    <th>मद</th><th style={{textAlign: 'right'}}>राशि</th>
                </tr>
              </thead>
              <tbody>
                {tableRows.map((_, index) => {
                  
                  // --- INCOME SIDE LOGIC (Left) ---
                  let incomeCols;
                  if (index === 0) {
                      incomeCols = (
                          <>
                              <td className="manual-row-bg" style={{ textAlign: 'left', padding: '5px 12px' }}>
                                  <input type="text" className="manual-table-input hide-in-pdf" placeholder="पिछला शेष (या अन्य विवरण)..." value={manualIncome1.category} onChange={(e) => setManualIncome1({...manualIncome1, category: e.target.value})} />
                                  <span className="show-in-pdf-only">{manualIncome1.category}</span>
                              </td>
                              <td className="text-green manual-row-bg" style={{ textAlign: 'right', fontWeight: 'bold', padding: '5px 12px' }}>
                                  <input type="number" className="manual-table-input hide-in-pdf" placeholder="राशि (₹)" value={manualIncome1.amount} onChange={(e) => setManualIncome1({...manualIncome1, amount: e.target.value})} />
                                  <span className="show-in-pdf-only">{manualIncome1.amount ? `₹ ${manualIncome1.amount}` : ""}</span>
                              </td>
                          </>
                      );
                  } else if (index === 1) {
                      incomeCols = (
                          <>
                              <td className="manual-row-bg" style={{ textAlign: 'left', padding: '5px 12px' }}>
                                  <input type="text" className="manual-table-input hide-in-pdf" placeholder="विवरण लिखें..." value={manualIncome2.category} onChange={(e) => setManualIncome2({...manualIncome2, category: e.target.value})} />
                                  <span className="show-in-pdf-only">{manualIncome2.category}</span>
                              </td>
                              <td className="text-green manual-row-bg" style={{ textAlign: 'right', fontWeight: 'bold', padding: '5px 12px' }}>
                                  <input type="number" className="manual-table-input hide-in-pdf" placeholder="राशि (₹)" value={manualIncome2.amount} onChange={(e) => setManualIncome2({...manualIncome2, amount: e.target.value})} />
                                  <span className="show-in-pdf-only">{manualIncome2.amount ? `₹ ${manualIncome2.amount}` : ""}</span>
                              </td>
                          </>
                      );
                  } else if (index >= 2 && index < incomeData.length + 2) {
                      const income = incomeData[index - 2];
                      incomeCols = (
                          <>
                              <td style={{ textAlign: 'left' }}>{income.category || "अन्य विवरण (Other)"}</td>
                              <td className="text-green" style={{ textAlign: 'right', fontWeight: 'bold' }}>₹ {income.amount}</td>
                          </>
                      );
                  } else {
                      incomeCols = <><td style={{ textAlign: 'left' }}></td><td style={{ textAlign: 'right' }}></td></>;
                  }

                  // --- EXPENSE SIDE LOGIC (Right) ---
                  let expenseCols;
                  if (index < expenseData.length) {
                      const expense = expenseData[index];
                      expenseCols = (
                          <>
                              <td style={{ textAlign: 'left' }}>{expense.category}</td>
                              <td className="text-red" style={{ textAlign: 'right', fontWeight: 'bold' }}>₹ {expense.amount}</td>
                          </>
                      );
                  } else if (index === expenseData.length) {
                      expenseCols = (
                          <>
                              <td className="manual-row-bg" style={{ textAlign: 'left', padding: '5px 12px' }}>
                                  <input type="text" className="manual-table-input hide-in-pdf" placeholder="बैंक में जमा (या अन्य व्यय)..." value={manualExpense1.category} onChange={(e) => setManualExpense1({...manualExpense1, category: e.target.value})} />
                                  <span className="show-in-pdf-only">{manualExpense1.category}</span>
                              </td>
                              <td className="text-red manual-row-bg" style={{ textAlign: 'right', fontWeight: 'bold', padding: '5px 12px' }}>
                                  <input type="number" className="manual-table-input hide-in-pdf" placeholder="राशि (₹)" value={manualExpense1.amount} onChange={(e) => setManualExpense1({...manualExpense1, amount: e.target.value})} />
                                  <span className="show-in-pdf-only">{manualExpense1.amount ? `₹ ${manualExpense1.amount}` : ""}</span>
                              </td>
                          </>
                      );
                  } else if (index === expenseData.length + 1) {
                      expenseCols = (
                          <>
                              <td className="manual-row-bg" style={{ textAlign: 'left', padding: '5px 12px' }}>
                                  <input type="text" className="manual-table-input hide-in-pdf" placeholder="विवरण लिखें..." value={manualExpense2.category} onChange={(e) => setManualExpense2({...manualExpense2, category: e.target.value})} />
                                  <span className="show-in-pdf-only">{manualExpense2.category}</span>
                              </td>
                              <td className="text-red manual-row-bg" style={{ textAlign: 'right', fontWeight: 'bold', padding: '5px 12px' }}>
                                  <input type="number" className="manual-table-input hide-in-pdf" placeholder="राशि (₹)" value={manualExpense2.amount} onChange={(e) => setManualExpense2({...manualExpense2, amount: e.target.value})} />
                                  <span className="show-in-pdf-only">{manualExpense2.amount ? `₹ ${manualExpense2.amount}` : ""}</span>
                              </td>
                          </>
                      );
                  } else {
                      expenseCols = <><td style={{ textAlign: 'left' }}></td><td style={{ textAlign: 'right' }}></td></>;
                  }

                  // Render Combined Row
                  return (
                      <tr key={index}>
                          {incomeCols}
                          {expenseCols}
                      </tr>
                  );
                })}
                
                {/* --- FOOTER TOTALS --- */}
                <tr className="table-footer-row">
                    <td style={{ textAlign: 'left' }}>कुल योग:</td>
                    <td style={{ textAlign: 'right' }} className="text-green">₹ {finalTotalIncome}</td>
                    <td style={{ textAlign: 'left' }}>कुल योग:</td>
                    <td style={{ textAlign: 'right' }} className="text-red">₹ {finalTotalExpense}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>

      {!isLoading && hasSearched && (
        <button className="fab-download-btn hide-in-pdf" onClick={() => window.print()} title="Print Ledger">
          <FaDownload />
        </button>
      )}
    </div>
  );
};

export default AayVyayPatrak;